<template>
  <el-form-item :label="i18nt('designer.setting.inputAlign')">
    <el-radio-group v-model="optionModel.inputAlign" class="radio-group-custom">
      <el-radio-button label="left" value="left"> {{ i18nt('designer.setting.leftAlign') }}</el-radio-button>
      <el-radio-button label="center" value="center"> {{ i18nt('designer.setting.centerAlign') }}</el-radio-button>
      <el-radio-button label="right" value="right"> {{ i18nt('designer.setting.rightAlign') }}</el-radio-button>
    </el-radio-group>
  </el-form-item>
</template>

<script>
import { computed, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';

export default {
  name: 'm-textarea-inputAlign-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();

    const noLabelSetting = computed(() => {
      return props.selectedWidget.type === 'static-text' || props.selectedWidget.type === 'html-text';
    });

    return {
      i18nt,
      ...toRefs(props),

      noLabelSetting,
    };
  },
};
</script>

<style lang="scss" scoped>
.radio-group-custom {
  :deep(.el-radio-button__inner) {
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
